// A dog photo is cropped into a different shape on a phone than on a desktop -
// the card gets wider and shorter, or stacks full width - so the crop that
// framed the dog's face on one can cut it off on the other.
//
// An inline background-position cannot be overridden by a media query, so the
// two positions ride along as custom properties and the stylesheet picks:
//
//   .photo            { background-position: var(--photo-pos, center); }
//   @media (max-width: 768px) {
//     .photo          { background-position: var(--photo-pos-mobile, var(--photo-pos, center)); }
//   }
//
// The mobile value is optional everywhere. Left out, it falls back to the
// desktop one and nothing changes.
export function photoPosition(desktop, mobile) {
  const base = desktop || 'center';
  return {
    '--photo-pos': base,
    '--photo-pos-mobile': mobile || base
  };
}

export default photoPosition;
